// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"718":"9d4d0149","820":"c61f9121"}[chunkId] + ".chunk.js";
};